
import axios from "axios";
import RedirectToApp from "../utils/RedirectToApp";
import Cookies from "universal-cookie/es6";
import {useState} from "react";
import {XCircleIcon} from "@heroicons/react/20/solid";
import {useEffect} from "react";
import {useNavigate} from "react-router-dom";

export default function ValidateOtp() {
    const navigate = useNavigate();
    const cookies = new Cookies()
    const name = cookies.get("name")

    const [error, setError] = useState("")
    const [verificationCode, setVerificationCode] = useState("")

    useEffect(() => {
        let loginToken = cookies.get("login-token")
        if (loginToken === undefined || loginToken === "") {
            navigate("/")
        }
    },[])

    function onSubmit(event) {
        event.preventDefault()
        let now = new Date()
        now.setHours(now.getHours() + 1)
        axios.post(process.env.REACT_APP_API_URL + "validate-otp", { "verification-code" : verificationCode, "token" : cookies.get("login-token")})
            .then(function (response) {
                if (response.data["success"] === true) {
                    console.log("Success")
                    cookies.set('token', response.data["result"]["token"], { expires : now, secure: true, domain: process.env.REACT_APP_COOKIE_NAME, path: '/' });
                    RedirectToApp()
                } else {
                    setError(response.data["error"]["description"])
                }
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    function handleVerificationCodeChange(e) {
        setVerificationCode(e.target.value)
    }

    return (
        <div className="flex min-h-full w-full flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
                <img
                    className="mx-auto h-12 w-auto"
                    src={process.env.REACT_APP_URL + "/images/logo-dark.png"}
                    alt="Your Company"
                />
                <h2 className="mt-6 text-center text-3xl font-bold tracking-tight text-gray-900">Welcome back{name && name !== "" ? " " + name + "," : "."}</h2>
                    <h2 className="text-center text-3xl font-bold tracking-tight text-gray-900">Enter your Verification Code</h2>
                <p className="mt-4 text-center text-sm text-gray-600">
                    Open the two-step-verification app on your mobile device to get your verification code.
                </p>
            </div>

            <div className="mt-6 sm:mx-auto sm:w-full sm:max-w-md">
                <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                    <form className="space-y-6" onSubmit={(e) => onSubmit(e)}>
                        { error && <div className="border-l-4 border-red-400 bg-red-50 p-4">
                            <div className="flex">
                                <div className="flex-shrink-0">
                                    <XCircleIcon className="h-5 w-5 text-red-800" aria-hidden="true" />
                                </div>
                                <div className="ml-3">
                                    <p className="text-sm text-red-700">
                                        {error}
                                    </p>
                                </div>
                            </div>
                        </div>}
                        <div>
                            <label htmlFor="verificationCode" className="block text-sm font-medium text-gray-700">
                                Verification Code
                            </label>
                            <div className="mt-1">
                                <input
                                    id="verificationCode"
                                    name="verificationCode"
                                    type="number"
                                    required
                                    onChange={handleVerificationCodeChange}
                                    className="block w-full appearance-none rounded-md border border-gray-300 px-3 py-2 placeholder-gray-400 shadow-sm focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                                />
                            </div>
                        </div>

                        <div>
                            <button
                                type="submit"
                                className="flex w-full justify-center rounded-md border border-transparent bg-indigo-600 py-2 px-4 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                            >
                                Authenticate
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
